// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Airdrop History — premium list/table (theme: #1E56F5, success #5EBA89, existing borders) */

/* Drop global #2B313C frame from style.css .market_section.spotorderhist — inner cards carry structure */
.market_section.spotorderhist.ah-spot-section {
  border: none;
}

.ah-list-premium {
  --ah-brand: #1e56f5;
  --ah-brand-soft: rgba(30, 86, 245, 0.1);
  --ah-success: #5eba89;
  --ah-success-soft: rgba(94, 186, 137, 0.16);
  --ah-warn: #e8a23c;
  --ah-warn-soft: rgba(232, 162, 60, 0.18);
  --ah-danger: #dc3545;
  --ah-danger-soft: rgba(220, 53, 69, 0.12);
  --ah-surface: #ffffff;
  --ah-surface-soft: #f8f9fa;
  --ah-border: #f0f0f0;
  --ah-border-strong: #e2e4e8;
  --ah-muted: #6c757d;
  --ah-text: rgba(0, 0, 0, 0.72);
  --ah-heading: #000000b8;
  --ah-shadow: 0 2px 12px rgba(30, 86, 245, 0.06);
  --ah-shadow-inset: inset 0 1px 0 rgba(255, 255, 255, 0.85);
  --ah-radius: 14px;
  --ah-radius-sm: 10px;
  --ah-transition: 0.2s ease;
}

.ah-list-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.65rem 0.75rem;
  margin-bottom: 0.85rem;
  padding: 0.65rem 0.75rem;
  background: var(--ah-surface-soft);
  border: 1px solid var(--ah-border);
  border-radius: var(--ah-radius-sm);
  box-shadow: var(--ah-shadow-inset);
}

.ah-list-toolbar .searchBar.custom-tabs {
  flex: 1 1 12rem;
  min-width: 0;
  max-width: 20rem;
}

.ah-list-toolbar .ah-toolbar-select {
  min-width: 9.5rem;
  border-radius: 50px;
  border: 1px solid var(--ah-border-strong);
  background: var(--ah-surface);
  font-size: 0.8rem;
  padding: 0.35rem 0.85rem;
  color: var(--ah-text);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.ah-list-toolbar .ah-toolbar-select:focus {
  border-color: var(--ah-brand);
  box-shadow: 0 0 0 0.2rem var(--ah-brand-soft);
  outline: none;
}

.ah-sort-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--ah-brand);
  background: var(--ah-surface);
  border: 1px solid var(--ah-border-strong);
  border-radius: 50px;
  padding: 0.35rem 0.85rem;
  cursor: pointer;
  transition: background var(--ah-transition), border-color var(--ah-transition), box-shadow var(--ah-transition);
}

.ah-sort-toggle:hover {
  border-color: rgba(30, 86, 245, 0.35);
  box-shadow: var(--ah-shadow);
}

.ah-sort-toggle[aria-pressed="true"] {
  background: var(--ah-brand-soft);
  border-color: rgba(30, 86, 245, 0.35);
}

.ah-filter-hint {
  width: 100%;
  flex-basis: 100%;
  font-size: 0.72rem;
  color: var(--ah-muted);
  margin: 0;
}

/* Table shell */
.ah-table-card {
  background: var(--ah-surface-soft);
  border: 1px solid var(--ah-border);
  border-radius: var(--ah-radius);
  padding: 0.5rem;
  box-shadow: var(--ah-shadow-inset);
}

.ah-table-scroll {
  border-radius: var(--ah-radius-sm);
  overflow: auto;
  max-height: min(62vh, 640px);
  background: var(--ah-surface);
  border: 1px solid var(--ah-border);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.ah-data-table {
  width: 100%;
  margin: 0;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.875rem;
  color: var(--ah-text);
}

.ah-data-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: var(--ah-surface);
  font-weight: 600;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--ah-muted);
  padding: 0.85rem 1rem;
  border-bottom: 1px solid var(--ah-border);
  white-space: nowrap;
  text-align: left;
  vertical-align: middle;
}

.ah-data-table thead th:last-child,
.ah-data-table tbody td:last-child {
  text-align: right;
}

.ah-data-table tbody td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--ah-border);
  vertical-align: middle;
  font-weight: 500;
  transition: background var(--ah-transition);
}

.ah-data-table tbody tr {
  background: var(--ah-surface);
}

.ah-data-table tbody tr:nth-child(even) {
  background: rgba(248, 249, 250, 0.85);
}

.ah-data-table tbody tr:hover td {
  background: rgba(30, 86, 245, 0.04);
}

.ah-data-table tbody tr:last-child td {
  border-bottom: none;
}

.ah-col-sno {
  width: 3.25rem;
  font-variant-numeric: tabular-nums;
  color: var(--ah-muted);
  font-weight: 600;
  font-size: 0.8rem;
}

.ah-col-round {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  color: var(--ah-heading);
}

.ah-vesting-id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 0.8rem;
  max-width: 11rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: middle;
}

.ah-token-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
}

.ah-token-icon-wrap {
  position: relative;
  width: 1.85rem;
  height: 1.85rem;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background: linear-gradient(140deg, var(--ah-brand) 0%, #1746c7 100%);
  box-shadow: 0 1px 4px rgba(30, 86, 245, 0.25);
}

.ah-token-icon-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ah-token-icon-wrap .ah-token-ri {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.05rem;
  color: #fff;
}

.ah-token-name {
  font-weight: 600;
  color: var(--ah-heading);
}

.ah-amount {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--ah-heading);
}

.ah-wallet-cell {
  font-size: 0.82rem;
  color: var(--ah-muted);
  font-weight: 600;
}

.ah-date-cell {
  font-size: 0.82rem;
  font-weight: 500;
  color: var(--ah-text);
  white-space: nowrap;
}

/* Status badges */
.ah-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.28rem 0.55rem;
  border-radius: 6px;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: 1px solid transparent;
  white-space: nowrap;
}

.ah-badge--pending {
  background: var(--ah-warn-soft);
  color: #b45c06;
  border-color: rgba(232, 162, 60, 0.45);
}

.ah-badge--released {
  background: var(--ah-success-soft);
  color: #2a8f5c;
  border-color: rgba(94, 186, 137, 0.4);
}

.ah-badge--locked {
  background: var(--ah-brand-soft);
  color: var(--ah-brand);
  border-color: rgba(30, 86, 245, 0.28);
}

.ah-badge--failed {
  background: var(--ah-danger-soft);
  color: #c82333;
  border-color: rgba(220, 53, 69, 0.35);
}

.ah-pagination-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.85rem;
  padding: 0 0.25rem;
  font-size: 0.82rem;
  color: var(--ah-muted);
  font-weight: 500;
}

/* Loading row */
.ah-loading-row td {
  padding: 2.5rem 1rem !important;
  text-align: center;
  color: var(--ah-muted);
  font-weight: 500;
  border-bottom: none !important;
}

/* Empty states */
.ah-empty-premium {
  padding: 2.75rem 1.5rem;
  text-align: center;
  background: var(--ah-surface);
  border-radius: var(--ah-radius-sm);
  border: 1px dashed var(--ah-border-strong);
}

.ah-empty-premium__icon {
  width: 4.5rem;
  height: 4.5rem;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--ah-brand-soft);
  color: var(--ah-brand);
  font-size: 2rem;
}

.ah-empty-premium__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--ah-heading);
  margin-bottom: 0.35rem;
}

.ah-empty-premium__sub {
  font-size: 0.88rem;
  color: var(--ah-muted);
  max-width: 22rem;
  margin: 0 auto 1.25rem;
  line-height: 1.5;
}

.ah-empty-premium .btn.custom-btn {
  border-radius: 50px;
  padding: 0.45rem 1.35rem;
  font-weight: 600;
}

.ah-empty-filter {
  padding: 2rem;
  text-align: center;
  color: var(--ah-muted);
  font-size: 0.9rem;
  font-weight: 500;
}

/* Mobile cards */
.ah-m-toolbar {
  margin-bottom: 0.75rem;
}

.ah-m-card {
  background: var(--ah-surface);
  border: 1px solid var(--ah-border);
  border-radius: var(--ah-radius-sm);
  padding: 1rem 1.1rem;
  box-shadow: var(--ah-shadow);
  transition: box-shadow var(--ah-transition), border-color var(--ah-transition), transform var(--ah-transition);
}

.ah-m-card:hover {
  box-shadow: 0 8px 24px rgba(30, 86, 245, 0.1);
  border-color: rgba(30, 86, 245, 0.22);
  transform: translateY(-1px);
}

.ah-m-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid var(--ah-border);
}

.ah-m-card__round {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--ah-muted);
  font-weight: 700;
  margin-bottom: 0.2rem;
}

.ah-m-card__amount {
  font-size: 1.1rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--ah-heading);
}

.ah-m-grid {
  display: grid;
  grid-template-columns: minmax(5rem, auto) 1fr;
  gap: 0.45rem 0.65rem;
  font-size: 0.78rem;
}

.ah-m-grid dt {
  margin: 0;
  color: #8b939e;
  font-weight: 600;
}

.ah-m-grid dd {
  margin: 0;
  color: var(--ah-text);
  font-weight: 500;
  word-break: break-word;
}

.ah-m-grid dd .ah-token-cell {
  margin-top: 0.15rem;
}

/* Dark theme */
body:not(.light_theme) .ah-list-premium {
  --ah-surface: #1a1d24;
  --ah-surface-soft: #12151a;
  --ah-border: rgba(255, 255, 255, 0.08);
  --ah-border-strong: rgba(255, 255, 255, 0.12);
  --ah-text: rgba(255, 255, 255, 0.82);
  --ah-heading: #ffffff;
  --ah-muted: #9aa3ad;
  --ah-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
  --ah-shadow-inset: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

body:not(.light_theme) .ah-data-table thead th {
  background: #1a1d24;
}

body:not(.light_theme) .ah-data-table tbody tr:nth-child(even) {
  background: rgba(255, 255, 255, 0.03);
}

body:not(.light_theme) .ah-data-table tbody tr:hover td {
  background: rgba(30, 86, 245, 0.12);
}

body:not(.light_theme) .ah-list-toolbar,
body:not(.light_theme) .ah-table-card {
  background: var(--ah-surface-soft);
}

body:not(.light_theme) .ah-toolbar-select {
  background: #1a1d24;
  color: var(--ah-text);
  border-color: var(--ah-border-strong);
}

body:not(.light_theme) .ah-sort-toggle {
  background: #1a1d24;
  color: #8eb0ff;
}

/* Summary stats — 2×2 grid on narrow phones; cards stay readable */
@media (max-width: 575.98px) {
  .ah-summary-cards .card-body {
    padding: 0.65rem 0.75rem !important;
  }
  .ah-summary-cards .small {
    font-size: 0.68rem;
    line-height: 1.25;
  }
  .ah-summary-cards .fw-semibold {
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/AirdropHistory/airdropHistory.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F,yGAAyG;AACzG;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,qBAAqB;EACrB,2CAA2C;EAC3C,kBAAkB;EAClB,wCAAwC;EACxC,oBAAoB;EACpB,yCAAyC;EACzC,qBAAqB;EACrB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,+CAA+C;EAC/C,0DAA0D;EAC1D,iBAAiB;EACjB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,sBAAsB;EACtB,wBAAwB;EACxB,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,6BAA6B;EAC7B,iBAAiB;EACjB,wBAAwB;EACxB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;EAC7B,yCAAyC;EACzC,mBAAmB;EACnB,wBAAwB;EACxB,eAAe;EACf,+GAA+G;AACjH;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,4BAA4B;EAC5B,6BAA6B;EAC7B,kCAAkC;EAClC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,yCAAyC;EACzC,sBAAsB;EACtB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,6EAA6E;EAC7E,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qEAAqE;EACrE,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,kCAAkC;EAClC,oBAAoB;EACpB,4BAA4B;EAC5B,8GAA8G;AAChH;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC;EACtC,6CAA6C;EAC7C,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;EAC3C,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mEAAmE;AACnE;EACE;IACE,mCAAmC;EACrC;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Airdrop History — premium list/table (theme: #1E56F5, success #5EBA89, existing borders) */\n\n/* Drop global #2B313C frame from style.css .market_section.spotorderhist — inner cards carry structure */\n.market_section.spotorderhist.ah-spot-section {\n  border: none;\n}\n\n.ah-list-premium {\n  --ah-brand: #1e56f5;\n  --ah-brand-soft: rgba(30, 86, 245, 0.1);\n  --ah-success: #5eba89;\n  --ah-success-soft: rgba(94, 186, 137, 0.16);\n  --ah-warn: #e8a23c;\n  --ah-warn-soft: rgba(232, 162, 60, 0.18);\n  --ah-danger: #dc3545;\n  --ah-danger-soft: rgba(220, 53, 69, 0.12);\n  --ah-surface: #ffffff;\n  --ah-surface-soft: #f8f9fa;\n  --ah-border: #f0f0f0;\n  --ah-border-strong: #e2e4e8;\n  --ah-muted: #6c757d;\n  --ah-text: rgba(0, 0, 0, 0.72);\n  --ah-heading: #000000b8;\n  --ah-shadow: 0 2px 12px rgba(30, 86, 245, 0.06);\n  --ah-shadow-inset: inset 0 1px 0 rgba(255, 255, 255, 0.85);\n  --ah-radius: 14px;\n  --ah-radius-sm: 10px;\n  --ah-transition: 0.2s ease;\n}\n\n.ah-list-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0.65rem 0.75rem;\n  margin-bottom: 0.85rem;\n  padding: 0.65rem 0.75rem;\n  background: var(--ah-surface-soft);\n  border: 1px solid var(--ah-border);\n  border-radius: var(--ah-radius-sm);\n  box-shadow: var(--ah-shadow-inset);\n}\n\n.ah-list-toolbar .searchBar.custom-tabs {\n  flex: 1 1 12rem;\n  min-width: 0;\n  max-width: 20rem;\n}\n\n.ah-list-toolbar .ah-toolbar-select {\n  min-width: 9.5rem;\n  border-radius: 50px;\n  border: 1px solid var(--ah-border-strong);\n  background: var(--ah-surface);\n  font-size: 0.8rem;\n  padding: 0.35rem 0.85rem;\n  color: var(--ah-text);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.ah-list-toolbar .ah-toolbar-select:focus {\n  border-color: var(--ah-brand);\n  box-shadow: 0 0 0 0.2rem var(--ah-brand-soft);\n  outline: none;\n}\n\n.ah-sort-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--ah-brand);\n  background: var(--ah-surface);\n  border: 1px solid var(--ah-border-strong);\n  border-radius: 50px;\n  padding: 0.35rem 0.85rem;\n  cursor: pointer;\n  transition: background var(--ah-transition), border-color var(--ah-transition), box-shadow var(--ah-transition);\n}\n\n.ah-sort-toggle:hover {\n  border-color: rgba(30, 86, 245, 0.35);\n  box-shadow: var(--ah-shadow);\n}\n\n.ah-sort-toggle[aria-pressed=\"true\"] {\n  background: var(--ah-brand-soft);\n  border-color: rgba(30, 86, 245, 0.35);\n}\n\n.ah-filter-hint {\n  width: 100%;\n  flex-basis: 100%;\n  font-size: 0.72rem;\n  color: var(--ah-muted);\n  margin: 0;\n}\n\n/* Table shell */\n.ah-table-card {\n  background: var(--ah-surface-soft);\n  border: 1px solid var(--ah-border);\n  border-radius: var(--ah-radius);\n  padding: 0.5rem;\n  box-shadow: var(--ah-shadow-inset);\n}\n\n.ah-table-scroll {\n  border-radius: var(--ah-radius-sm);\n  overflow: auto;\n  max-height: min(62vh, 640px);\n  background: var(--ah-surface);\n  border: 1px solid var(--ah-border);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.ah-data-table {\n  width: 100%;\n  margin: 0;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.875rem;\n  color: var(--ah-text);\n}\n\n.ah-data-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: var(--ah-surface);\n  font-weight: 600;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--ah-muted);\n  padding: 0.85rem 1rem;\n  border-bottom: 1px solid var(--ah-border);\n  white-space: nowrap;\n  text-align: left;\n  vertical-align: middle;\n}\n\n.ah-data-table thead th:last-child,\n.ah-data-table tbody td:last-child {\n  text-align: right;\n}\n\n.ah-data-table tbody td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid var(--ah-border);\n  vertical-align: middle;\n  font-weight: 500;\n  transition: background var(--ah-transition);\n}\n\n.ah-data-table tbody tr {\n  background: var(--ah-surface);\n}\n\n.ah-data-table tbody tr:nth-child(even) {\n  background: rgba(248, 249, 250, 0.85);\n}\n\n.ah-data-table tbody tr:hover td {\n  background: rgba(30, 86, 245, 0.04);\n}\n\n.ah-data-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.ah-col-sno {\n  width: 3.25rem;\n  font-variant-numeric: tabular-nums;\n  color: var(--ah-muted);\n  font-weight: 600;\n  font-size: 0.8rem;\n}\n\n.ah-col-round {\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  color: var(--ah-heading);\n}\n\n.ah-vesting-id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 0.8rem;\n  max-width: 11rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.ah-token-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 0;\n}\n\n.ah-token-icon-wrap {\n  position: relative;\n  width: 1.85rem;\n  height: 1.85rem;\n  flex-shrink: 0;\n  border-radius: 50%;\n  overflow: hidden;\n  background: linear-gradient(140deg, var(--ah-brand) 0%, #1746c7 100%);\n  box-shadow: 0 1px 4px rgba(30, 86, 245, 0.25);\n}\n\n.ah-token-icon-wrap img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.ah-token-icon-wrap .ah-token-ri {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.05rem;\n  color: #fff;\n}\n\n.ah-token-name {\n  font-weight: 600;\n  color: var(--ah-heading);\n}\n\n.ah-amount {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--ah-heading);\n}\n\n.ah-wallet-cell {\n  font-size: 0.82rem;\n  color: var(--ah-muted);\n  font-weight: 600;\n}\n\n.ah-date-cell {\n  font-size: 0.82rem;\n  font-weight: 500;\n  color: var(--ah-text);\n  white-space: nowrap;\n}\n\n/* Status badges */\n.ah-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.28rem 0.55rem;\n  border-radius: 6px;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border: 1px solid transparent;\n  white-space: nowrap;\n}\n\n.ah-badge--pending {\n  background: var(--ah-warn-soft);\n  color: #b45c06;\n  border-color: rgba(232, 162, 60, 0.45);\n}\n\n.ah-badge--released {\n  background: var(--ah-success-soft);\n  color: #2a8f5c;\n  border-color: rgba(94, 186, 137, 0.4);\n}\n\n.ah-badge--locked {\n  background: var(--ah-brand-soft);\n  color: var(--ah-brand);\n  border-color: rgba(30, 86, 245, 0.28);\n}\n\n.ah-badge--failed {\n  background: var(--ah-danger-soft);\n  color: #c82333;\n  border-color: rgba(220, 53, 69, 0.35);\n}\n\n.ah-pagination-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-top: 0.85rem;\n  padding: 0 0.25rem;\n  font-size: 0.82rem;\n  color: var(--ah-muted);\n  font-weight: 500;\n}\n\n/* Loading row */\n.ah-loading-row td {\n  padding: 2.5rem 1rem !important;\n  text-align: center;\n  color: var(--ah-muted);\n  font-weight: 500;\n  border-bottom: none !important;\n}\n\n/* Empty states */\n.ah-empty-premium {\n  padding: 2.75rem 1.5rem;\n  text-align: center;\n  background: var(--ah-surface);\n  border-radius: var(--ah-radius-sm);\n  border: 1px dashed var(--ah-border-strong);\n}\n\n.ah-empty-premium__icon {\n  width: 4.5rem;\n  height: 4.5rem;\n  margin: 0 auto 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--ah-brand-soft);\n  color: var(--ah-brand);\n  font-size: 2rem;\n}\n\n.ah-empty-premium__title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: var(--ah-heading);\n  margin-bottom: 0.35rem;\n}\n\n.ah-empty-premium__sub {\n  font-size: 0.88rem;\n  color: var(--ah-muted);\n  max-width: 22rem;\n  margin: 0 auto 1.25rem;\n  line-height: 1.5;\n}\n\n.ah-empty-premium .btn.custom-btn {\n  border-radius: 50px;\n  padding: 0.45rem 1.35rem;\n  font-weight: 600;\n}\n\n.ah-empty-filter {\n  padding: 2rem;\n  text-align: center;\n  color: var(--ah-muted);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* Mobile cards */\n.ah-m-toolbar {\n  margin-bottom: 0.75rem;\n}\n\n.ah-m-card {\n  background: var(--ah-surface);\n  border: 1px solid var(--ah-border);\n  border-radius: var(--ah-radius-sm);\n  padding: 1rem 1.1rem;\n  box-shadow: var(--ah-shadow);\n  transition: box-shadow var(--ah-transition), border-color var(--ah-transition), transform var(--ah-transition);\n}\n\n.ah-m-card:hover {\n  box-shadow: 0 8px 24px rgba(30, 86, 245, 0.1);\n  border-color: rgba(30, 86, 245, 0.22);\n  transform: translateY(-1px);\n}\n\n.ah-m-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid var(--ah-border);\n}\n\n.ah-m-card__round {\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--ah-muted);\n  font-weight: 700;\n  margin-bottom: 0.2rem;\n}\n\n.ah-m-card__amount {\n  font-size: 1.1rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: var(--ah-heading);\n}\n\n.ah-m-grid {\n  display: grid;\n  grid-template-columns: minmax(5rem, auto) 1fr;\n  gap: 0.45rem 0.65rem;\n  font-size: 0.78rem;\n}\n\n.ah-m-grid dt {\n  margin: 0;\n  color: #8b939e;\n  font-weight: 600;\n}\n\n.ah-m-grid dd {\n  margin: 0;\n  color: var(--ah-text);\n  font-weight: 500;\n  word-break: break-word;\n}\n\n.ah-m-grid dd .ah-token-cell {\n  margin-top: 0.15rem;\n}\n\n/* Dark theme */\nbody:not(.light_theme) .ah-list-premium {\n  --ah-surface: #1a1d24;\n  --ah-surface-soft: #12151a;\n  --ah-border: rgba(255, 255, 255, 0.08);\n  --ah-border-strong: rgba(255, 255, 255, 0.12);\n  --ah-text: rgba(255, 255, 255, 0.82);\n  --ah-heading: #ffffff;\n  --ah-muted: #9aa3ad;\n  --ah-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n  --ah-shadow-inset: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\nbody:not(.light_theme) .ah-data-table thead th {\n  background: #1a1d24;\n}\n\nbody:not(.light_theme) .ah-data-table tbody tr:nth-child(even) {\n  background: rgba(255, 255, 255, 0.03);\n}\n\nbody:not(.light_theme) .ah-data-table tbody tr:hover td {\n  background: rgba(30, 86, 245, 0.12);\n}\n\nbody:not(.light_theme) .ah-list-toolbar,\nbody:not(.light_theme) .ah-table-card {\n  background: var(--ah-surface-soft);\n}\n\nbody:not(.light_theme) .ah-toolbar-select {\n  background: #1a1d24;\n  color: var(--ah-text);\n  border-color: var(--ah-border-strong);\n}\n\nbody:not(.light_theme) .ah-sort-toggle {\n  background: #1a1d24;\n  color: #8eb0ff;\n}\n\n/* Summary stats — 2×2 grid on narrow phones; cards stay readable */\n@media (max-width: 575.98px) {\n  .ah-summary-cards .card-body {\n    padding: 0.65rem 0.75rem !important;\n  }\n  .ah-summary-cards .small {\n    font-size: 0.68rem;\n    line-height: 1.25;\n  }\n  .ah-summary-cards .fw-semibold {\n    font-size: 0.95rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
